import { apiClient, type ShipmentOrderInputHistoryListEntity } from '@/libs/api'

export type FetchShipmentOrderHistoriesQuery = {
  tenantKey: string
  dcId: number
  originSiteId?: number
  destSiteId?: number
  customerId?: number
  shipmentCategoryId?: number
}

// APIに渡すクエリパラメータの型定義
type ShipmentOrderHistoriesQueryParams = {
  originSiteId?: number
  destSiteId?: number
  customerId?: number
  shipmentCategoryId?: number
  dcId: number
  page?: number
}

export type FetchShipmentOrderHistoriesResponse = {
  data: ShipmentOrderInputHistoryListEntity[]
}

// 配送依頼履歴SELECT用 一覧取得API
export const fetchShipmentOrderHistories = async (
  {
    tenantKey,
    dcId,
    originSiteId,
    destSiteId,
    customerId,
    shipmentCategoryId
  }: FetchShipmentOrderHistoriesQuery,
  signal?: AbortSignal
): Promise<FetchShipmentOrderHistoriesResponse> => {
  const query: ShipmentOrderHistoriesQueryParams = {
    originSiteId,
    destSiteId,
    customerId,
    shipmentCategoryId,
    dcId,
    page: -1
  }

  const data = await apiClient
    ._tenant(tenantKey)
    .shipment_orders.histories.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data: data.data
  }
}
